import styles from "./Styles/Button.module.css"

function Button(props) {
    return <div style={{marginBottom:props.mb,marginTop:props.mt,marginLeft:props.ml,marginRight:props.mr}} className={styles.button}>
        <button style={{borderRadius:props.radius || 5, height:props.height || 40, width:props.width || '100%',backgroundColor:(props.bgColor) || (props.disabled ? '#D2DADE' : '#111942'),color:props.disabled ? '#79919E' : '#fff',fontWeight:props.medium ? 400 : 600}} onClick={props.onClickHandler}>{props.title}</button>
    </div>
}

export default Button